export default __webpack_public_path__ + "static/media/ticket-item.75109020.png";